import {
  BaseNodeAdditionalDataType,
  BaseNodeComponentType,
  BaseNodeDataType,
  BaseNodePropsType,
  SpecializedNodeProps,
} from "../WorkflowUtils";
import BaseNode from "./BaseNode";

type EndNodeAdditionalDataType = BaseNodeAdditionalDataType & {};

type EndNodeDataType = BaseNodeDataType<EndNodeAdditionalDataType>;

type Props = {} & BaseNodePropsType<EndNodeDataType>;

/**
 * End node.
 *
 * Used to define the workflow's entry point.
 * Is unique, there can be only one EndNode, and it's required and must always be present.
 *
 * Displays a start icon.
 * Has only one east port.
 */
const EndNode: BaseNodeComponentType<Props> = (props) => {
  return (
    <BaseNode {...props}>
      {(nodeProps: SpecializedNodeProps<EndNodeDataType>) => {
        return (
          <div className={`node-content end-content`}>
            End
            <p>[ {nodeProps.node.id} ]</p>
          </div>
        );
      }}
    </BaseNode>
  );
};

export default EndNode;
